import {RcfaUserInfo} from '@domain/rcfa'

import {Task} from '../../../types/common.types'

export interface TaskGroup {
  id?: number
  title?: string
  tasks?: Array<Task>
}

export interface TaskCreate {
  nodeId?: number
  title: string
  description: string
  assignee: RcfaUserInfo | null
  dueDate?: string | null
}

export enum TaskStatuses {
  Pending = 'Pending',
  Ongoing = 'Ongoing',
  Done = 'Done'
}
